import { useUser } from '@descope/react-sdk'

export const useIsSupportUser = (): boolean => {
  const { user } = useUser()
  return !!(user && user.roleNames?.includes('Support User'))
}
